import React from 'react'
import { Col } from 'react-bootstrap';
import ScrollAnimation from 'react-animate-on-scroll';
import TitleSection from '../TitleSection';
import { Btn1, Feature, ImageDiv, Textsection } from './style';

export default function AboutSection() {
    return (
        <>
            <Col xs={12} sm={12} md={12} lg={6} >
                <ScrollAnimation animateIn="animate__fadeInLeft">
                    <ImageDiv>
                        <img src={"/images/slide_1.jpg"} />
                    </ImageDiv>
                </ScrollAnimation>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6} >
                <ScrollAnimation animateIn="animate__fadeInRight">
                    <Textsection>
                        <TitleSection text="Why Choose EDUCATE ?  " />
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            Ut odit minus soluta, similique!
                        </p>
                        <Feature>
                            <i className="fas fa-check-circle"></i>
                            <span>Techinnical Collage  Best Cool Enviornment </span>
                        </Feature>
                        <Feature>
                            <i className="fas fa-check-circle"></i>
                            <span>Online Education System With Super Saver inst.  </span>
                        </Feature>
                        <Feature>
                            <i className="fas fa-check-circle"></i>
                            <span>Many Many Popular Course  Most Powerfull Solution.  </span>
                        </Feature>
                        <Feature>
                            <i className="fas fa-check-circle"></i>
                            <span>Techinnical Collage  Best Cool Enviornment </span>
                        </Feature>
                        <Feature>
                            <i className="fas fa-check-circle"></i>
                            <span>Many Many Popular Course  Most Powerfull Solution.  </span>
                        </Feature>
                        <Feature>
                            <i className="fas fa-check-circle"></i>
                            <span>Many Many Popular Course  Most Powerfull Solution.  </span>
                        </Feature>
                        <Btn1 variant="primary">View Courses</Btn1>
                    </Textsection>
                </ScrollAnimation>
            </Col>
        </>
    )
}
